exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.message[data-v-3a573a92] {\n  width: 100%;\n  padding: 16px;\n  font-size: 16px;\n  border-radius: 4px;\n  color: #2C3235;\n  letter-spacing: 0.2px;\n  line-height: 16px;\n  margin-bottom: 32px;\n}\n.message.error[data-v-3a573a92] {\n    background: rgba(196, 75, 73, 0.04);\n    border: 1px solid rgba(196, 75, 73, 0.16);\n}\n.message.success[data-v-3a573a92] {\n    background: rgba(68, 184, 90, 0.04);\n    border: 1px solid rgba(68, 184, 90, 0.16);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a573a92","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Message.vue
// module id = 353
// module chunks = 1